import PropTypes from 'prop-types';
import { useAnalytics } from 'use-analytics';
import { useSelector } from 'react-redux';

const ReferLabelRoomDescription = ({ room }) => {
  const { travelAgency } = useSelector((store) => store.user);
  const virtuosoRateLabelInRoomDescription = travelAgency && travelAgency.settings
  && travelAgency.settings.virtuosoRateLabelInRoomDescription;
  const { track } = useAnalytics();
  const handleLinkToVirtuosoWebsite = () => {
    track('redirectToVirtuosoWebsite');
  };

  return (room && ((room.ratePlanClientId || room.ratePlanCode) === 'API'
|| (room.ratePlanClientId || room.ratePlanCode) === 'VMC') ? (
  <div
    role="button"
    aria-label="Click"
    onClick={() => handleLinkToVirtuosoWebsite()}
    onKeyDown={handleLinkToVirtuosoWebsite}
    dangerouslySetInnerHTML={{ __html: virtuosoRateLabelInRoomDescription }}
    tabIndex={0}
  />
    ) : <></>);
};

ReferLabelRoomDescription.propTypes = {
  room: PropTypes.shape().isRequired,
};

export default ReferLabelRoomDescription;
